/**
 * Route parsing and URL helper for Pondy Connect Web
 * Supports canonical deep-linking for all views and settings extensions
 */

export const parseRoute = (rawPath) => {
  if (!rawPath || rawPath === '/') {
    return { view: 'connect', subView: null };
  }

  let decoded = rawPath;
  try {
    decoded = decodeURIComponent(rawPath);
  } catch (_) {}

  const path = decoded.toLowerCase().replace(/\/+$/, '');

  // Main feature navigation routes (direct and /settings/ aliases)
  if (
    path === '/settings/home' || 
    path === '/home' || 
    path === '/connect' || 
    path === '/listings'
  ) {
    return { view: 'connect', subView: null };
  }

  if (
    path === '/settings/discover' || 
    path === '/discover' || 
    path === '/market-square' || 
    path === '/marketplace' || 
    path === '/classifieds'
  ) {
    return { view: 'market-square', subView: null };
  }

  if (
    path === '/settings/property' || 
    path === '/property' || 
    path === '/real-estate' || 
    path === '/realestate' || 
    path === '/properties'
  ) {
    return { view: 'real-estate', subView: null };
  }

  if (
    path === '/settings/appointment' || 
    path === '/settings/appointments' || 
    path === '/settings/slotify' || 
    path === '/appointment' || 
    path === '/appointments' || 
    path === '/slotify' || 
    path === '/booking' || 
    path === '/bookings'
  ) {
    return { view: 'slotify', subView: null };
  }

  if (path === '/settings/booster' || path === '/booster') {
    return { view: 'booster', subView: null };
  }

  if (
    path === '/settings/favourites' || 
    path === '/settings/favorites' || 
    path === '/favourites' || 
    path === '/favorites'
  ) {
    return { view: 'favourites', subView: null };
  }

  if (path === '/settings/notifications' || path === '/notifications') {
    return { view: 'notifications', subView: null };
  }

  // Settings Subviews
  // 1. About Us
  if (
    path === '/settings/aboutus' || 
    path === '/settings/about-us' || 
    path === '/settings/about' || 
    path === '/aboutus' || 
    path === '/about-us' || 
    path === '/about'
  ) {
    return { view: 'settings', subView: 'about' };
  }

  // 2. How To Use / Guide
  if (
    path === '/settings/howtouse' || 
    path === '/settings/how-to-use' || 
    path === '/settings/guide' || 
    path === '/howtouse' || 
    path === '/how-to-use' || 
    path === '/guide'
  ) {
    return { view: 'settings', subView: 'guide' };
  }

  // 3. Legal & Business Information
  if (
    path === '/settings/legal&businessinformation' ||
    path === '/settings/legal-and-business-information' ||
    path === '/settings/legalandbusinessinformation' ||
    path === '/settings/legal-business-information' ||
    path === '/settings/legalbusinessinformation' ||
    path === '/settings/legal&business' ||
    path === '/settings/business' ||
    path === '/settings/legal' ||
    path === '/settings/business-info' ||
    path === '/settings/businessinfo' ||
    path === '/settings/legal-info' ||
    path === '/settings/legalinfo' ||
    path === '/legal&businessinformation' ||
    path === '/legal-and-business-information' ||
    path === '/legalandbusinessinformation' ||
    path === '/legal-business-information' ||
    path === '/legalbusinessinformation' ||
    path === '/legal&business' ||
    path === '/business' ||
    path === '/legal' ||
    path === '/business-info' ||
    path === '/businessinfo' ||
    path === '/legal-info' ||
    path === '/legalinfo'
  ) {
    return { view: 'settings', subView: 'business' };
  }

  // 4. Privacy Policy
  if (
    path === '/settings/privacy' || 
    path === '/settings/privacypolicy' || 
    path === '/settings/privacy-policy' || 
    path === '/privacy-policy' || 
    path === '/privacy'
  ) {
    return { view: 'settings', subView: 'privacy' };
  }

  // 5. Terms & Conditions
  if (
    path === '/settings/terms' || 
    path === '/settings/termsandconditions' || 
    path === '/settings/terms-and-conditions' || 
    path === '/terms-and-conditions' || 
    path === '/terms'
  ) {
    return { view: 'settings', subView: 'terms' };
  }

  // 6. Child Safety Standards
  if (
    path === '/settings/childsafety' || 
    path === '/settings/child-safety' || 
    path === '/settings/safety' || 
    path === '/child-safety' || 
    path === '/safety'
  ) {
    return { view: 'settings', subView: 'safety' };
  }

  // 7. Tips & Tricks
  if (
    path === '/settings/tips' || 
    path === '/settings/tipsandtricks' || 
    path === '/settings/tips-and-tricks' || 
    path === '/tips'
  ) {
    return { view: 'settings', subView: 'tips' };
  }

  // 8. Feedback
  if (path === '/settings/feedback' || path === '/feedback') {
    return { view: 'settings', subView: 'feedback' };
  }

  // 9. Download App
  if (path === '/settings/download' || path === '/download') {
    return { view: 'download', subView: 'download' };
  }

  // 10. Blocked Users
  if (
    path === '/settings/blocked' || 
    path === '/settings/blockedusers' || 
    path === '/settings/blocked-users' || 
    path === '/blocked'
  ) {
    return { view: 'settings', subView: 'blocked' };
  }

  // 11. Following
  if (path === '/settings/following' || path === '/following') {
    return { view: 'settings', subView: 'following' };
  }

  // 12. Interested Events
  if (
    path === '/settings/events' || 
    path === '/settings/interestedevents' || 
    path === '/settings/interested-events' || 
    path === '/events'
  ) {
    return { view: 'settings', subView: 'events' };
  }

  // 13. Edit Profile
  if (
    path === '/settings/profile' || 
    path === '/settings/editprofile' || 
    path === '/settings/edit-profile' || 
    path === '/profile'
  ) {
    return { view: 'settings', subView: 'profile' };
  }

  // 14. Delete Account
  if (
    path === '/settings/delete' || 
    path === '/settings/delete-account' || 
    path === '/delete-account'
  ) {
    return { view: 'settings', subView: 'delete' };
  }

  // 15. Base Settings Menu
  if (path === '/settings' || path === '/settings/menu') {
    return { view: 'settings', subView: 'menu' };
  }

  return null;
};

export const getCanonicalUrl = (view, subView = null, id = null) => {
  if (id) {
    const cleanId = typeof id === 'object' ? (id.Retail_ID || id.RetialID) : id;
    return `/ad/${cleanId}`;
  }

  if (view === 'settings') {
    switch (subView) {
      case 'about':
        return '/settings/aboutus';
      case 'guide':
        return '/settings/howtouse';
      case 'business':
        return '/settings/Legal&BusinessInformation';
      case 'privacy':
        return '/settings/privacy';
      case 'terms':
        return '/settings/terms';
      case 'safety':
        return '/settings/childsafety';
      case 'tips':
        return '/settings/tips';
      case 'feedback':
        return '/settings/feedback';
      case 'download':
        return '/settings/download';
      case 'blocked':
        return '/settings/blocked';
      case 'following':
        return '/settings/following';
      case 'events':
        return '/settings/events';
      case 'profile':
        return '/settings/profile';
      case 'delete':
        return '/settings/delete-account';
      case 'menu':
      default:
        return '/settings';
    }
  }

  switch (view) {
    case 'connect':
    case 'listings':
      return '/home';
    case 'market-square':
      return '/discover';
    case 'real-estate':
      return '/property';
    case 'slotify':
      return '/appointment';
    case 'booster':
      return '/booster';
    case 'favourites':
      return '/favourites';
    case 'notifications':
      return '/notifications';
    case 'download':
      return '/settings/download';
    case 'about':
      return '/settings/aboutus';
    case 'guide':
      return '/settings/howtouse';
    case 'business':
      return '/settings/Legal&BusinessInformation';
    case 'privacy':
      return '/settings/privacy';
    case 'terms':
      return '/settings/terms';
    case 'safety':
      return '/settings/childsafety';
    case 'tips':
      return '/settings/tips';
    case 'feedback':
      return '/settings/feedback';
    case 'blocked':
      return '/settings/blocked';
    case 'following':
      return '/settings/following';
    case 'events':
      return '/settings/events';
    case 'profile':
      return '/settings/profile';
    default:
      return `/${view}`;
  }
};
